import styled, { css } from 'styled-components'

export const ButtonContainer = styled.button`
  ${({ theme, secondary, isGoogle, isFacebook, isApple, hasIcon }) => css`
    ${theme.fonts.bold};
    border: 2px solid ${theme.colors.primary.default};
    background-color: ${theme.colors.primary.default};
    color: ${theme.colors.primary.contrastText};
    border-radius: 1.5rem;
    opacity: 1;
    text-align: left;
    letter-spacing: 0;
    text-transform: uppercase;
    min-width: 6.5rem;
    height: 2.5rem;
    font-size: 0.75rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2;
    cursor: pointer;
    margin-bottom: 1rem;
    padding: 0 1rem;
    width: fit-content;

    @supports not (width: fit-content) {
      display: table;
      vertical-align: middle;
    }

    &:hover {
      background-color: ${theme.colors.primary.hover};
      border: 2px solid ${theme.colors.primary.hover};
    }
    &:focus {
      background-color: ${theme.colors.primary.hover};
      border: 2px solid ${theme.colors.primary.hover};
    }

    ${hasIcon &&
    css`
      svg {
        margin-left: 0.5rem;
        max-width: 28px;
        height: auto;
        path {
          stroke: inherit;
        }
      }
    `}

    ${secondary &&
    css`
      margin-right: 2rem;
      background-color: ${theme.colors.primary.contrastText};
      color: ${theme.colors.primary.default};

      &:hover {
        background-color: ${theme.colors.primary.hover};
        color: ${theme.colors.primary.contrastText};
      }
      &:focus {
        background-color: ${theme.colors.primary.hover};
        color: ${theme.colors.primary.contrastText};
      }
    `}

    ${isGoogle &&
    css`
      margin-right: 2rem;
      background-color: ${theme.colors.googleRed};
      border: 2px solid ${theme.colors.googleRed};
    `}


    ${isFacebook &&
    css`
      background-color: ${theme.colors.facebookBlue};
      border: 2px solid ${theme.colors.facebookBlue};
    `}

    ${isApple &&
    css`
      background-color: ${theme.colors.black};
      border: 2px solid ${theme.colors.black};
      color: ${theme.colors.white};

      svg path {
        fill: ${theme.colors.white};
      }
    `}
  `}
`
